<div class="limiter">
  <div class="container-login100">
    <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>
    <div class="card" *ngIf="showThankyouText">
      <div
        style="
          border-radius: 200px;
          height: 200px;
          width: 200px;
          background: #f8faf5;
          margin: 0 auto;
        "
      >
        <i class="checkmark">✓</i>
      </div>
      <h1 class="success-header">Success</h1>
      <p class="success-text">
        Thank You<br />
        Please Login With Your New Credentials.
      </p>
    </div>
    <form
      [formGroup]="forgotPasswordForm"
      class="validate-user-form"
      *ngIf="!showThankyouText"
    >
      <div class="text-center">
        <img
          class="login-logo"
          height="120px"
          src="assets/images/ez-logo.png"
          alt="Logo"
        />
      </div>
      <h4 class="text-center">Generate new password</h4>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label>{{ "EMAIL" | translate }}</label>
            <input
              formControlName="userName"
              class="form-control"
              type="email"
            />
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label
              >{{ "NEW_PASSWORD" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="d-flex">
              <input
                autocomplete="new-password"
                formControlName="password"
                class="form-control"
                [type]="showPassword ? 'text' : 'password'"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-toggle-password"
                  (click)="togglePasswordVisibility()"
                >
                  <i
                    [ngClass]="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  ></i>
                </button>
              </div>
            </div>
            <div
              *ngIf="
                forgotPasswordForm.get('password').touched &&
                forgotPasswordForm.get('password').errors
              "
            >
              <div
                class="text-danger"
                *ngIf="forgotPasswordForm.get('password').errors?.required"
              >
                {{ "PASSWORD_IS_REQUIRED" | translate }}
              </div>
              <div
                class="text-danger"
                *ngIf="forgotPasswordForm.get('password').errors?.minlength"
              >
                You have to enter at least 6 digit
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <div class="form-group">
            <label
              >{{ "CONFIRM_PASSWORD" | translate }}
              <span class="text-danger">*</span></label
            >
            <div class="d-flex">
              <input
                autocomplete="new-password"
                formControlName="confirmPassword"
                class="form-control"
                [type]="showConfirmPassword ? 'text' : 'password'"
              />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn btn-toggle-password"
                  (click)="toggleConfirmPasswordVisibility()"
                >
                  <i
                    [ngClass]="
                      showConfirmPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
                    "
                  ></i>
                </button>
              </div>
            </div>
            <div
              *ngIf="
                forgotPasswordForm.get('confirmPassword').touched &&
                forgotPasswordForm.get('confirmPassword').errors
              "
            >
              <div
                class="text-danger"
                *ngIf="
                  forgotPasswordForm.get('confirmPassword').errors?.required
                "
              >
                {{ "CONFIRM_PASSWORD_IS_REQUIRED" | translate }}
              </div>
            </div>
            <div
              class="text-danger"
              *ngIf="
                forgotPasswordForm.get('confirmPassword').touched &&
                forgotPasswordForm.hasError('notSame')
              "
            >
              {{ "PASSWORDS_DO_NOT_MATCH" | translate }}
            </div>
            <div
              class="text-danger"
              *ngIf="
                forgotPasswordForm.get('confirmPassword').errors?.minlength
              "
            >
              You have to enter at least 6 digit
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-12">
          <button
            class="btn btn-success btn-sm m-right-10"
            (click)="changePassword()"
            cdkFocusInitial
            [disabled]="forgotPasswordForm?.invalid"
          >
            <i class="fas fa-save"></i> Change Password
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
